export default {
  "Add inventory": "Ajouter un inventaire",
  // --- stock-batch-meta.tsx ---
  "Batch Code": "Code de lot",
  "Unit Price": "Prix unitaire",
  "Product Shop": "Boutique de produit",
  Warehouse: "Entrepôt",
  "Expiry Date": "Date d'expiration",
  Actions: "Actions",

  // --- stock-batch-form.tsx ---
  "Product Shop ID": "ID de la boutique de produit",
  "Warehouse ID": "ID de l'entrepôt",
  "Supplier ID": "ID du fournisseur",
  "Shop ID": "ID de la boutique",

  // --- select-stock-batch.tsx ---
  "Stock Batch": "Lot de stock",
  "Search stock batch by batch code, supplier, warehouse, shop, or product shop":
    "Rechercher un lot de stock par code de lot, fournisseur, entrepôt, boutique ou boutique de produit",
  "Edit Selection": "Modifier la sélection",
  "No stock batches found": "Aucun lot de stock trouvé",

  // --- create-stock-batch-modal.tsx ---
  "Create a new stock batch": "Créer un nouveau lot de stock",

  // --- edit-stock-batch-modal.tsx ---
  "Edit Stock Batch": "Modifier le lot de stock",

  // --- view-stock-batch-modal.tsx & view-stock-batch-block.tsx ---
  "General Information": "Informations générales",
  Supplier: "Fournisseur",
  Shop: "Boutique",
  "Created At": "Créé le",
  "Updated At": "Mis à jour le",

  // --- delete-stock-batch-modal.tsx ---
  "Do you really want to delete this Stock Batch?":
    "Voulez-vous vraiment supprimer ce lot de stock ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Avertissement : Cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",

  // --- stock-batch-list-block.tsx ---
  "Add stock batch": "Ajouter un lot de stock",

  // --- General ---
  Submit: "Soumettre",

  Inventory: "Inventaire",
  inventory: "inventaire",
  "Add Inventory": "Ajouter à l'inventaire",
  "Product informations": "Informations sur le produit",
  Product: "Produit",
  product: "produit",
  supplier: "fournisseur",
  warehouse: "entrepôt",
  Quantity: "Quantité",
  quantity: "quantité",
  Amount: "Montant",
  amount: "montant",
  "Manufacturing Date": "Date de fabrication",
  "Description / Observation": "Description / Observation",
  "Payment informations": "Informations de paiement",
  "Add Payment": "Ajouter un paiement",
  Create: "Créer",
  creer: "créer",
  "More data": "Plus de données",
  Description: "Description",
  "Search batch, product or shop":
    "Rechercher un lot, un produit ou une boutique",
  Batch: "Lot",
  batch: "lot",
  Qty: "Qté",
  qty: "qté",
  Price: "Prix",
  price: "prix",
  Exp: "Exp",
  "No warehouse": "Aucun entrepôt",
  Change: "Modifier",
  change: "modifier",
  SKU: "SKU",
  "N/A": "N/A",
  Expiry: "Expiration",
  shop: "boutique",
  "Cost Price": "Prix de revient",
  Supply: "Approvisionnement",
  Sold: "Vendu",
  sold: "vendu",
  "Supply Ret": "Ret. Approv",
  "Sale Ret": "Ret. Vente",
  Readjusted: "Réajusté",
  "Trf In": "Trf Entrant",
  "Trf Out": "Trf Sortant",
  Edit: "Modifier",
  Reajust: "Réajuster",
  "Quantity Readjusted": "Quantité réajustée",
  "Quantity return by customers": "Quantité retournée par les clients",
  "Quantity Sold": "Quantité vendue",
  "Quantity return to suppliers": "Quantité retournée aux fournisseurs",
  "Quantity Tranfered In": "Quantité transférée (Entrée)",
  "Quantity Tranfered Out": "Quantité transférée (Sortie)",
  Products: "Produits",
  products: "produits",
  Suppliers: "Fournisseurs",
  suppliers: "fournisseurs",
  "Stock Batchs": "Lots de stock",
  Orders: "Commandes",
  orders: "commandes",
  "Stock transfers": "Transferts de stock",
  "Sale returns": "Retours sur vente",
  "Supply returns": "Retours fournisseurs",
  "Total supply cost": "Coût total d'approvisionnement",
  "Total sales volume": "Volume total des ventes",
  "Total supply returns": "Total retours fournisseurs",
  "Total sale returns": "Total retours sur vente",
  "Gross margin": "Marge brute",
  "Supply cost": "Coût d'approvisionnement",
  Sales: "Ventes",
  sales: "ventes",
  "Sales returns": "Retours sur ventes",
  "Top products": "Top produits",
  "Top categories": "Top catégories",
  "Top Customers": "Top clients",
  "Top Suppliers": "Top fournisseurs",
  "Top sale returned products": "Top produits retournés (ventes)",
  "Top supply returned products": "Top produits retournés (fournisseurs)",
  "Supply and Sales": "Approvisionnements et Ventes",
  "top products": "top produits",
  "Incomes and expenses": "Revenus et dépenses",
  Debts: "Dettes",
  debts: "dettes",
  "Total Balance": "Solde total",
  "Gross Debt": "Dette brute",
  "Last 7 days sales": "Ventes des 7 derniers jours",
  "top categories": "top catégories",
  "Products sold": "Produits vendus",
  "products sold": "produits vendus",
  "Total Revenue": "Revenu total",
  "total revenue": "revenu total",
  "Total expenses": "Total des dépenses",
  "total expenses": "total des dépenses",
  "Net Profit": "Bénéfice net",
  "net profit": "bénéfice net",
};
